import { render, staticRenderFns } from "./ShippingDetailsItemView.vue?vue&type=template&id=3ae1f9dc&"
import script from "./ShippingDetailsItemView.vue?vue&type=script&lang=js&"
export * from "./ShippingDetailsItemView.vue?vue&type=script&lang=js&"
import style0 from "./ShippingDetailsItemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ae1f9dc')) {
      api.createRecord('3ae1f9dc', component.options)
    } else {
      api.reload('3ae1f9dc', component.options)
    }
    module.hot.accept("./ShippingDetailsItemView.vue?vue&type=template&id=3ae1f9dc&", function () {
      api.rerender('3ae1f9dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/ShippingDetailsItemView.vue"
export default component.exports